<template>
  <div class="login-form">
    <form method @submit.prevent="handleSubmit">
      <h1>Login here</h1>
      <font-awesome-icon icon="user-secret" size="6x" />
      <div class="form-group">
        <label for="username">Username</label>
        <br />
        <input
          class="form-control"
          type="text"
          v-model="username"
          placeholder="Username"
          id="username"
        />
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <br />
        <input
          class="form-control"
          type="password"
          v-model="password"
          placeholder="Password"
          id="password"
        />
      </div>

      <div class="form-group">
        <button type="submit" class="btn btn-success">Login</button>
      </div>
      <h3 v-if="login_started">Verifying credentials...</h3>
      <div class="alert alert-danger" v-if="error !== ''">{{ error }}</div>
    </form>
  </div>
</template>

<script>
import {Auth} from '@aws-amplify/auth'
import AmplifyStore from "@/store/store";

export default {
  name: "LoginForm",
  data() {
    return {
      login_started: false,
      username: "",
      password: "",
      error: "",
      login_data_loaded: false,
      authConfig: {
        signInConfig: {
          isSignUpDisplayed: false
        }
      }
    };
  },
  mounted() {
    this.login_data_loaded = true;
  },
  computed: {
    user() {
      return AmplifyStore.state.user;
    }
  },
  methods: {
    handleSubmit: function() {
      this.login_started = true;
      Auth.signIn(this.username, this.password)
        .then(user => {
          this.$emit("submit");
          AmplifyStore.state.user = user;
          this.login_started = false;
        })
        .catch(err => {
          this.error = err.message;
          this.login_started = false;
        });
    }
  }
};
</script>


<style scoped>
.login-form {
  margin: auto;
  max-width: 400px;
  width: 25%;
}
</style>
